import { RESET_STORE } from "./actionType";


export function resetStore() {
	return { type: RESET_STORE };
}



// WEBPACK FOOTER //
// ./src/actions/applicationActions.js